import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { addExtras } from 'apps/auth/actions/extraAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import Failed from 'apps/auth/components/paysendPlus/subscription/Failed';
import Success from 'apps/auth/components/paysendPlus/subscription/Success';
import Waiting from 'apps/auth/components/paysendPlus/subscription/Waiting';
import BasePage from 'apps/auth/components/utils/BasePage';
import Spinner from 'apps/auth/components/utils/Spinner/Spinner';
import { STATUS_OK } from 'apps/auth/constants/Constants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logWarn } from 'apps/auth/helpers/clientLogger';

const PlusComplexStatusPage = (props) => {
    const [screen, setScreen] = useState('PRELOADER');
    const [counter, setCounter] = useState(0);
    const popupRef = useRef(null);
    const intervalId = useRef(null);

    useEffect(() => {
        if (counter < 6 && screen === 'PRELOADER') {
            intervalId.current = setInterval(() => {
                setCounter((prevCounter) => prevCounter + 1);
                checkSubscriptionPaymentStatus();
            }, props.setRefreshTimer);
        }
        return () => clearTimeout(intervalId.current);
    }, [counter]);

    const getStatus = () => {
        return props.status;
    };

    const checkSubscriptionPaymentStatus = () => {
        apiFetchData('/auth/plus/subscription/payment/status/info', {})
            .then((json) => {
                if (json.extra) {
                    props.addExtras(json.extra);
                    if (json.extra.status > STATUS_OK) {
                        setScreen('FAILED');
                    } else if (json.extra.status === STATUS_OK) {
                        setScreen('SUCCESS');
                    } else if (counter >= 5) {
                        setScreen('WAITING');
                    } else {
                        setScreen('PRELOADER');
                    }
                }
                if (json.messages) {
                    props.updatePageMessages(json.messages);
                }
                if (json.redirectTo) {
                    window.location.replace(json.redirectTo);
                }
            })
            .catch((error) => logWarn(error));
    };

    const status = getStatus();

    const render = (currentScreen) => {
        switch (currentScreen) {
            case 'PRELOADER':
                return <Spinner forceShow={true} />;
            case 'FAILED':
                return <Failed status={status} popupRef={popupRef} />;
            case 'SUCCESS':
                return <Success status={status} />;
            case 'WAITING':
                return <Waiting status={status} />;
        }
    };

    return (
        <BaseLayout>
            {render(screen)}
            <PopupNew ref={popupRef} />
        </BaseLayout>
    );
};

const mapStateToProps = (state) => {
    return {
        status: state.extra.status,
        setRefreshTimer: state.extra.setRefreshTimer,
    };
};

export default connect(mapStateToProps, { addExtras, updatePageMessages })(BasePage(PlusComplexStatusPage));
